import React, { useEffect } from 'react';

import { connect } from 'react-redux';

import BobPage from '../../../components/BobPage';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';

import ConversionPanel from './ConversionPanel';

import * as ConversionActions from '../../../actions/conversionActions';

import * as classes from './Conversions.module.css';

const Conversions = ({
    activeNavCompany,
    fetchConversions,
    setSelectedConversion,
    ...props
}) => {

    useEffect(() => {
        const init = async () => {
            await fetchConversions(activeNavCompany.id);
        };

        if (activeNavCompany.id) init();
    }, [activeNavCompany]);

    useEffect(() => {
        return () => {
            setSelectedConversion({});
        };
    }, []);

    return (
        <BobPage>
            <div className={classes.AttributeManagementPage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={classes.TitlePanel}>
                    Conversion
                </div>
                <div className={classes.ContainerPanel}>
                    <ConversionPanel />
                </div>
            </div>
        </BobPage>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany
    };
};

const mapDispatchToProps = {
    ...ConversionActions
};

export default connect(mapStateToProps, mapDispatchToProps)(Conversions);
